import { reservationAxios } from '../../../core/rest/axios';
export async function loadDaysList(activityId, branchId) {
    return reservationAxios.get('/dny', { params: { pobockaId: branchId, cinnostId: activityId } })
        .then((response) => response.data);
}
